module.exports = __webpack_public_path__ + "static/media/iceman26.7a43c485.JPG";